;
import { ErrorPageComponent } from './components/error-page/error-page.component'// app.module.ts
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { AppComponent } from './app.component';
import { Routing } from './app.routing';
import { AuthGuard } from './_guard/index';

import { AuthenticationService } from './services/authentication.service';
import { HomepageComponent } from './homepage/homepage.component';


// Angular Materials
import { MatButtonModule, MatCardModule, MatMenuModule, MatToolbarModule, MatIconModule, MatGridListModule, 
    MatSidenavModule, MatCheckboxModule, MatPaginatorModule, MatDialogModule, MatProgressSpinnerModule } from '@angular/material';


// Angular Animation
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FlexLayoutModule } from "@angular/flex-layout";

import { UserComponent } from './user/user.component';
import { GameComponent } from './game/game.component';

import { CountDown } from "ng2-date-countdown";
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NgxSiemaModule } from 'ngx-siema';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyHttpLogInterceptor } from './services/http.interceptor';


// Homemade directives
import { DivbackgroundimgDirective } from './directives/divbackgroundimg.directive';

// Homemade Pipes
import { isEmptyPipe } from './pipes/isEmpty.pipe';
import { numberFrPipe } from './pipes/numberFr.pipe';
import { addHourToDatePipe } from './pipes/addHourToDate.pipe';
import { DecimalPipe } from '@angular/common';

import { SimpleNotificationsModule } from 'angular4-notifications';
import { UserNotificationsComponent } from './components/user-notifications/user-notifications.component';

// BETA : Angular-instantsearch module : https://algolia.gitbooks.io/angular-instantsearch/
import { NgAisModule } from 'angular-instantsearch';
import { ResetPasswordComponent } from './components/users/reset-password/reset-password.component';
import { UserProfileComponent } from './components/users/user-profile/user-profile.component';

// Form date format
import { DateValueAccessorModule } from 'angular-date-value-accessor';

import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
import { CompanyProfileComponent } from './components/company/company-profile/company-profile.component';
import { AddGameComponent } from './components/company/add-game/add-game.component';

// Drag and drop
import { DndModule } from 'ng2-dnd';

// loader button
import { LaddaModule } from 'angular2-ladda';
import { CompanyDashboardComponent, PrizeComponent, PopinWinner } from './components/company/company-dashboard/company-dashboard.component';

import { GenericTableModule } from '@angular-generic-table/core';
import { CompanyStatsComponent } from './components/company/company-stats/company-stats.component';

// Charts
import { ChartsModule } from 'ng2-charts';

@NgModule({
    declarations: [
        AppComponent,
        HomepageComponent,
        UserComponent,
        GameComponent,
        CountDown,
        FooterComponent,
        HeaderComponent,
        DivbackgroundimgDirective,
        isEmptyPipe,
        numberFrPipe,
        addHourToDatePipe,
        ErrorPageComponent,
        UserNotificationsComponent,
        ResetPasswordComponent,
        UserProfileComponent,
        CompanyProfileComponent,
        AddGameComponent,
        CompanyDashboardComponent,
        PrizeComponent,
        PopinWinner,
        CompanyStatsComponent
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        Routing,
        MatButtonModule, 
        MatCardModule, 
        MatMenuModule, 
        MatToolbarModule, 
        MatIconModule,
        MatGridListModule,
        MatSidenavModule,
        MatCheckboxModule,
        BrowserAnimationsModule,
        FlexLayoutModule,
        NgxSiemaModule.forRoot(),
        MatPaginatorModule,
        SimpleNotificationsModule.forRoot(),
        HttpClientModule,
        NgAisModule.forRoot(),
        MatDialogModule,
        MatProgressSpinnerModule,
        DateValueAccessorModule,
        Ng4GeoautocompleteModule.forRoot(),
        DndModule.forRoot(),
        LaddaModule.forRoot({
            style: "expand-left",
            spinnerSize: 40,
            spinnerColor: "grey",
            spinnerLines: 12
        }),
        GenericTableModule,
        ChartsModule
    ],
    entryComponents: [
        PrizeComponent,
        PopinWinner
    ],
    providers: [
        {
            // provide: LOCALE_ID,
            // useValue: 'fr-FR',
            provide: HTTP_INTERCEPTORS,
            useClass: MyHttpLogInterceptor, 
            multi: true 
        },
        AuthGuard,
        AuthenticationService,
        DecimalPipe
    ],
    bootstrap: [AppComponent, HeaderComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/app.module.ts